import script from "./HorizontalSpendingChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./HorizontalSpendingChart.vue?vue&type=script&setup=true&lang=ts"

import "./HorizontalSpendingChart.vue?vue&type=style&index=0&id=c4b47bda&scoped=true&lang=css"
import "./HorizontalSpendingChart.vue?vue&type=style&index=1&id=c4b47bda&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4b47bda"]])

export default __exports__